import React, { useState, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
const EnrollmentNotification = ({title, message}) => {
  const [show, setShow] = useState<boolean>(true);
  const navigate = useNavigate();
  const handleClose = useCallback(() => {
    navigate('/');
    setShow(false);
  }, []);
  
  return (
    <Modal show={show} onHide={handleClose} className='modal-container' centered>
      <Modal.Header closeButton>
      {/* <label>Organization is successfully Enrolled. Please login from<Link to="/">here</Link> to start using the application!</label> */}
      <div className="container text-center mt-5">
        <h1 className="display-4">{title}</h1>
        <p className="lead">{message}</p>
        <p>Please contact the administrator for further assistance.</p>
        <Link to="/" >Go to login</Link>
      </div>
      </Modal.Header>
    </Modal>
  );
}

export default EnrollmentNotification;